import { render, staticRenderFns } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=67e1ace0&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
import style0 from "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=67e1ace0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1ace0",
  null
  
)

export default component.exports